import React from 'react'
import styles from './MicrositeNoindexBadge.module.css'
import { EyeOff } from 'lucide-react'

/**
 * MicrositeNoindexBadge
 * Warning pill shown when a page is set to noindex (hidden from
 * search engines). Renders nothing if noindex is false, so it's
 * safe to drop inline in a table cell unconditionally.
 *
 * Usage:
 *   <MicrositeNoindexBadge noindex={row.noindex} />
 */
const MicrositeNoindexBadge = ({ noindex }) => {
    if (!noindex) return null
    return (
        <span className={styles.badge}>
            <EyeOff size={11} />
            noindex
        </span>
    )
}

export default MicrositeNoindexBadge